import React from "react";
import { Link } from "react-router-dom";
import img1 from "../../assets/img/item/s1.png";
import img2 from "../../assets/img/item/s2.png";
import img3 from "../../assets/img/item/s3.png";
import img4 from "../../assets/img/item/s4.png";
import img5 from "../../assets/img/item/s5.png";
import { Star } from "../../icon/IconTheme";
const data = [
	{
		title: "Hashima 1",
		img: img1,
		color: "#4CA9DD",
	},
	{
		title: "Hashima 1",
		img: img2,
		color: "#D14CDD",
	},
	{
		title: "Hashima 1",
		img: img3,
		color: "#FF9900",
	},
	{
		title: "Hashima 1",
		img: img4,
		color: "#4C6CDD",
	},
	{
		title: "Hashima 1",
		img: img5,
		color: "#4CA9DD",
	},
];

const SidebarBottom = () => {
	return (
		<>
			<div className="sidebar-bottom">
				<h4 className="title">Top Hash Score</h4>
				<div className="hascore-area">
					{data &&
						data.map(({ title, img, color }, i) => (
							<Link to="#" className="hascore-item" key={i}>
								<div className="hascore-item-top">
									<img src={img} alt="" />
									<div className="title">{title}</div>
									<div className="rating">
										(10) <Star />
									</div>
								</div>
								<div className="hascore-item-bottom">
									<div className="progress">
										<div
											className="progress-bar"
											style={{
												width: "80%",
												background: color,
											}}
										></div>
									</div>
									<span className="span">
										177T <small>Th/s</small>
									</span>
								</div>
							</Link>
						))}
				</div>
				<Link to="#" className="cmn-btn">
					View All
				</Link>
			</div>
		</>
	);
};

export default SidebarBottom;
